export const SITE_URL = "https://dentalleadslab.com";
export const SITE_NAME = "Dental Leads Lab";
export const OG_IMAGE = `${SITE_URL}/og-image.png`;

export const EMAILS = {
  hello: "hello@dentalleadslab.com",
  support: "support@dentalleadslab.com",
  billing: "billing@dentalleadslab.com",
  info: "info@dentalleadslab.com",
};

export const PHONE = "+91 8433696777";
export const PHONE_RAW = "+918433696777";
